/**
 * FX (REV-21512): the display-currency twin values a super-table row carries through the print
 * and export pipelines. Transient and derived — deliberately NOT on the persisted
 * `ISuperTableRow`, because the twins are computed from the FX-stamped mapping trees on every
 * render and must never be stored.
 *
 * `NotesDisplayMapper` writes them (print preview and `applyFxTwinsForExport`) and reads them back
 * when it emits the CY_FX / PV_FX cells; the app's Excel export reads them too. Declared here
 * rather than inside that mapper so the reader across the library boundary is bound by the same
 * type instead of relying on an untyped row.
 */
export interface IFxPrintRow {
    __fxPrintCY?: number | null;
    __fxPrintPY?: number | null;
}
